import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=427e02e6"
import script from "./Merch.vue?vue&type=script&lang=js"
export * from "./Merch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports